module.exports = __webpack_public_path__ + "img/pic_biuro.59a152f4.svg";